import { useEffect, useState } from "react";

import Multimedia from "@sharedComponents/multimedia";
import ShareWidgets from "@stadium/ui/src/components/share-widgets";
import TippyTooltip from "@stadium/ui/src/components/tooltip/tippy-tooltip";

import BottomIconHideWrapper from "@stadium/shared/src/components/bottom-icon-hide-wrapper";

import shareShopsImg from "assets/images/share-shops-img.png";

import { InternalButton } from "@components/shared/buttons";

import Modal from "@stadium/ui/src/components/ModalNew";
import {
  CloseButton,
  ModalBody,
  ModalContent,
  ModalDialog,
  ModalHeader,
  ModalFooter,
} from "@stadium/ui/src/components/ModalNew/utils";

import styles from "./main.module.scss";

const { FacebookShareWidget, TwitterShareWidget, LinkedinShareWidget, EmailShareWidget } =
  ShareWidgets;

const DEFAULT_DELAY = 3000;
const bgStyleSocialIcon = { fill: "white" };
const iconFillColor = "#4F5052";

const ShareLinkModal = ({ closeModal, data = {} }) => {
  const { shareUrl = "/", title = "", emailSubject = "", emailBody = "", isMobileDevice } = data;
  const [showTippy, setShowTippy] = useState(false);

  useEffect(() => {
    let timeout;
    if (showTippy) timeout = setTimeout(() => setShowTippy(false), DEFAULT_DELAY);

    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [showTippy]);

  const copyToClipboard = (text) => navigator.clipboard.writeText(text);

  const copyStoreLinkHandler = () => {
    copyToClipboard(shareUrl).catch((err) => {
      throw err;
    });
    setShowTippy(true);
  };

  const renderShareLinkModalContent = () => (
    <Modal newModal mobileBottomDrawer className={styles.shareModal} closeModal={closeModal}>
      <ModalDialog className={styles.shareModalDialog}>
        <ModalContent className={styles.modalContent}>
          <ModalHeader className={styles.modalHeader}>
            <div className={styles.modalTitle}>Share Template</div>
            <CloseButton onClick={closeModal} className={styles.iconClose} />
          </ModalHeader>

          <ModalBody className={styles.modalBody}>
            <div className={styles.shareModalImageRow}>
              <Multimedia type="image" src={shareShopsImg} alt="" height={256} width={256} />
            </div>
            <div className={styles.shareButtonGroup}>
              <FacebookShareWidget
                shareUrl={shareUrl}
                title={title}
                className={styles.socialButton}
                iconFillColor={iconFillColor}
                bgStyle={bgStyleSocialIcon}
              />
              <TwitterShareWidget
                shareUrl={shareUrl}
                title={title}
                className={styles.socialButton}
                iconFillColor={iconFillColor}
                bgStyle={bgStyleSocialIcon}
              />
              <LinkedinShareWidget
                shareUrl={shareUrl}
                className={styles.socialButton}
                iconFillColor={iconFillColor}
                bgStyle={bgStyleSocialIcon}
              />
              <EmailShareWidget
                shareUrl={shareUrl}
                subject={emailSubject}
                body={emailBody}
                className={styles.socialButton}
                iconFillColor={iconFillColor}
                bgStyle={bgStyleSocialIcon}
              />
              <TippyTooltip content="Link Copied" visible={showTippy}>
                <button onClick={copyStoreLinkHandler} className={styles.socialButton}>
                  <div className="icon-link" />
                </button>
              </TippyTooltip>
            </div>
          </ModalBody>

          <ModalFooter className={styles.modalFooter}>
            <InternalButton className={styles.buttonDone} onClick={closeModal} styleType="primary">
              DONE
            </InternalButton>
          </ModalFooter>
        </ModalContent>
      </ModalDialog>
    </Modal>
  );

  return isMobileDevice ? (
    <BottomIconHideWrapper>{renderShareLinkModalContent()}</BottomIconHideWrapper>
  ) : (
    renderShareLinkModalContent()
  );
};

export default ShareLinkModal;
